import $ from 'jquery';
import FJBase from './FJBase';

class FJ3D extends FJBase {
    constructor(props) {
        super(props);

        props = props || {};
        this._name = 'FJ3D';
        this._offset = typeof props.offset != 'undefined' ? props.offset : 10; // 阴影偏移距离，比例值
        this._angle = typeof props.angle != 'undefined' ? props.angle : 45; // 阴影偏移角度
        this._color = (props && props.color) || '#f00000'; // 阴影颜色
        this._textColor = (props && props.textColor) || ''; // 文字颜色
        this._position = (props && props.position) || 'absolute';

        this._blur = typeof props.blur != 'undefined' ? props.blur : 2; // 阴影模糊半径，比例值
    }

    encode() {
        return {
            name: this._name,
            offset: this._offset,
            angle: this._angle,
            color: this._color,
            textColor: this._textColor,
        };
    }
    decode(data) {
        this._offset = data.offset;
        this._angle = data.angle;
        this._color = data.color;
        this._textColor = data.textColor;
    }
    clone() {
        let object = new FJ3D();
        object.decode(this);

        return object;
    }
    get name() {
        return this._name;
    }

    set color(color) {
        this._color = color;
    }
    get color() {
        return this._color;
    }

    /**
     * @desc 更新所有行文字文字样式
     * @param styleData
     */
    updateAllLineStyle(styleData) {
        if (!this._layer) return;
        let lineLayers = this.getLineLayers();
        for (let i = 0; i < lineLayers.length; i++) {
            let ele = lineLayers[i];
            if (this._textColor) {
                $(ele).css({
                    ...styleData,
                    color: this._textColor,
                });
            } else {
                $(ele).css(styleData);
            }
        }

        let fontSize = parseFloat(styleData.fontSize);
        let ref = (0.2 * fontSize * this.offset) / 100;
        let x = ref * Math.cos((this.angle / 180) * Math.PI);
        let y = ref * Math.sin((this.angle / 180) * Math.PI);
        let max = Math.max(Math.abs(x), Math.abs(y));

        if (max > 0) {
            let deltaX = x / max;
            let deltaY = y / max;

            const textShadowList = [];

            for (let i = 1; i <= max; i++) {
                textShadowList.push(`${i * deltaX}px ${i * deltaY}px ${this._blur}px ${this._color}`);
            }

            $(this._layer).css({
                textShadow: textShadowList.join(','),
            });
        }
    }

    /**
     * @desc更新所有行文字文字样式
     * @param styleData
     * @param lineIdx
     */
    updateStyle(styleData, lineIdx) {
        if (!this._layer) return;
        let lineLayers = this.getLineLayers();
        if (lineIdx < lineLayers.length) {
            let ele = lineLayers[lineIdx];
            if (this._textColor) {
                $(ele).css({
                    ...styleData,
                    color: this._textColor,
                });
            } else {
                $(ele).css(styleData);
            }
        }

        let fontSize = parseFloat(styleData.fontSize);
        let ref = (0.2 * fontSize * this.offset) / 100;
        let x = ref * Math.cos((this.angle / 180) * Math.PI);
        let y = ref * Math.sin((this.angle / 180) * Math.PI);
        let max = Math.max(Math.abs(x), Math.abs(y));

        if (max > 0) {
            let deltaX = x / max;
            let deltaY = y / max;

            const textShadowList = [];

            for (let i = 1; i <= max; i++) {
                textShadowList.push(`${i * deltaX}px ${i * deltaY}px ${this._blur}px ${this._color}`);
            }

            $(this._layer).css({
                textShadow: textShadowList.join(','),
            });
        }
    }

    isEqual(style) {
        let ret = true;

        ret &= this._offset === style.offset;
        ret &= this._angle === style.angle;
        ret &= this._color === style.color;

        return ret;
    }

    clear() {
        if (this._layer && this._layer.parentNode) {
            this._layer.parentNode.removeChild(this._layer);
        }
    }
}

export default FJ3D;
